import styled from 'styled-components';

export const CollectionsSectionContainer = styled.div<{ $isCompact?: boolean }>`
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '1.25rem' : '2rem')};
`;

export const CollectionsTitle = styled.div<{ $isCompact?: boolean }>`
  margin-bottom: ${({ $isCompact }) => ($isCompact ? '0.6rem' : '1rem')};
`;

export const CollectionsGrid = styled.div<{ $isCompact?: boolean }>`
  display: flex;
  gap: ${({ $isCompact }) => ($isCompact ? '0.4rem' : '0.75rem')};
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;

export const CollectionPill = styled.button<{
  active?: boolean;
  isSmart?: boolean;
  $isCompact?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  transition: all 0.15s ease;

  ${({ $isCompact, active, theme }) =>
    $isCompact
      ? `
    padding: 0.25rem 0.65rem;
    border-radius: 999px;
    font-size: 0.74rem;
    font-weight: 600;
    border: 1px solid ${active ? theme.colors.primary : theme.colors.border.light};
    background: ${active ? theme.colors.primary : theme.colors.background};
    color: ${active ? '#ffffff' : theme.colors.text.secondary};

    &:hover {
      border-color: ${theme.colors.primary};
      color: ${active ? '#ffffff' : theme.colors.primary};
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.primary};
      outline-offset: 2px;
    }
  `
      : `
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-size: 0.875rem;
    font-weight: 500;
    border: 1px solid ${active ? '#1976d2' : '#e0e0e0'};
    background: ${active ? '#1976d2' : 'white'};
    color: ${active ? 'white' : '#333'};

    &:hover {
      border-color: #1976d2;
      background: ${active ? '#1976d2' : '#f5f5f5'};
    }
  `}
`;


